module.exports = __webpack_public_path__ + "img/logo.575e1960.png";